export default __webpack_public_path__ + "static/media/steamMethaneReforming.574a5052.svg";